import { useState } from "react";
import { Files } from "lucide-react";

import { EvidenceModal } from "@/components/today/evidence-modal";
import { Button } from "@/components/ui/button";
import { ActionQueueLabels } from "@/lib/action-queue";
import { djs } from "@/lib/djs";
import type { GuidanceFeedback } from "@/types/triage-guidance";

export function GuidanceFeedbackEntry({ feedback }: { feedback: GuidanceFeedback }) {
	const [evidenceOpen, setEvidenceOpen] = useState(false);

	return (
		<div className="min-w-0 text-sm">
			<p className="font-medium text-foreground">{feedback.name}</p>
			<p className="mt-0.5 text-xs text-muted-foreground">{feedback.task}</p>
			<p className="mt-2 whitespace-pre-wrap text-foreground">{feedback.note}</p>
			<div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-muted-foreground">
				<span>
					{ActionQueueLabels.event[feedback.type]} por {ActionQueueLabels.role[feedback.actor]}
				</span>
				<time dateTime={djs(feedback.created_at).toISOString()}>
					{djs(feedback.created_at).tz("America/Sao_Paulo").format("DD/MM/YYYY HH:mm")}
				</time>
				{feedback.sources.length > 0 && (
					<Button type="button" variant="ghost" size="sm" onClick={() => setEvidenceOpen(true)}>
						<Files /> fontes
					</Button>
				)}
			</div>
			{evidenceOpen && (
				<EvidenceModal
					personId={feedback.person_id}
					sources={feedback.sources}
					title={feedback.task}
					onClose={() => setEvidenceOpen(false)}
				/>
			)}
		</div>
	);
}
